import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const TimelineData = [
    {
        id: "1",
        date: "8 October 2021 -- 27 February 2022",
        title: "Fly Me To Knowledge",
        description: "This program is a 5 months series of trainings, workshops, and field trips dedicated to educating students about programming languages, machine learning and IOT",
        image: "FlyMeTK",
        workingStep: [
            {
                stepTitle: "Special Activities",
                stepDescription: "The special activities that will enhance the impact of the event are the event's booth, the robotics companies field trips, the weekly trainings & workshops, Opening & Closing ceremonies and the social media marketing.",
            },
            {
                stepTitle: "Communication Plan",
                stepDescription: "The organizing commitee of Fly Me To Knowledge program is working on creating a website for the program in addition to sharing its details on social media such as Facebook, Twitter, Instagram and LinkedIn, plus the appointment of ambassadors in every university.",
            },
            {
                stepTitle: "Expected Attendance",
                stepDescription: "From 100 to 200 IEEE & non-IEEE members",
            },
            {
                stepTitle: "Type of Audience",
                stepDescription: "Students",
            },
        ]
    },
    {
        id: "2",
        date: "20 December 2021 -- 22 December 2021",
        title: "Tunisian Students & Young Professionals congress",
        description: "The Tunisian Students and Young Professionals Congress (TSYP) is the IEEE Tunisian Annual Meeting where more than 500 engineering students from several Tunisian universities, as well as young professionals, gather to learn further details about the IEEE technical, professional, and educational benefits; and to discuss the future engineering challenges worldwide and in Tunisia. The purpose of this event is to help IEEE Members gain further insight, enabling exchange of knowledge and skills. Our SB participates in this event annualy and actively engages in its competitions and workshops. We also won various awards in the TSYP for our work.",
        image: "TSYP",
        workingStep: [
            {
                stepTitle: "",
                stepDescription: "",
            },
        ]
    },
]

const Timeline = () => {
    return (
        <div className="rn-timeline-wrapper timeline-style-one position-relative">
            <div className="timeline-line"></div>
            {/* Start Single Timeline  */}

            {TimelineData.map((data, index) =>(
                <div className="single-timeline mt--50" key={index}>
                    <div className="timeline-dot">
                        <div className="time-line-circle"></div>
                    </div>
                    <div className="single-content">
                        <div className="inner">
                            <div className="row row--30 align-items-center">
                                <div className="order-2 order-lg-1 col-lg-6 mt_md--40 mt_sm--40">
                                    <div className="content">
                                        <ScrollAnimation 
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}>
                                            <span className="date-of-timeline">{data.date}</span>
                                        </ScrollAnimation>

                                        <ScrollAnimation 
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}>
                                            <h2 className="title">{data.title}</h2>
                                        </ScrollAnimation>

                                        <ScrollAnimation 
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}>
                                            <p className="description">{data.description}</p>
                                        </ScrollAnimation>

                                        <div className="row row--30">
                                            {data.workingStep.map((data, index)=>(
                                                <div className="col-lg- col-md-6 col-12" key={index}>
                                                    <div className="working-list">
                                                        <ScrollAnimation 
                                                        animateIn="fadeInUp"
                                                        animateOut="fadeInOut"
                                                        animateOnce={true}>
                                                            <h5 className="working-title">{data.stepTitle}</h5>
                                                        </ScrollAnimation>

                                                        <ScrollAnimation 
                                                        animateIn="fadeInUp"
                                                        animateOut="fadeInOut"
                                                        animateOnce={true}>
                                                            <p>{data.stepDescription}</p>
                                                        </ScrollAnimation>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="read-morebtn">
                                            <ScrollAnimation 
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}>
                                                
                                            </ScrollAnimation>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-1 order-lg-2 col-lg-6">
                                    <div className="thumbnail">
                                        <img className="w-100" src={`./images/timeline/${data.image}.jpg`} alt="Corporate React Template" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
           
            {/* End Single Timeline  */}
        </div>
    )
}

export default Timeline;
